function isCommentBodyText(element) {
  return !("type" in element) && "text" in element && typeof element.text === "string";
}
function isCommentBodyMention(element) {
  return "type" in element && element.type === "mention";
}
function isCommentBodyLink(element) {
  return "type" in element && element.type === "link";
}
function toAbsoluteUrl(url) {
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  } else if (url.startsWith("www.")) {
    return "https://" + url;
  }
  return;
}

export { isCommentBodyLink, isCommentBodyMention, isCommentBodyText, toAbsoluteUrl };
//# sourceMappingURL=utils.mjs.map
